import React from 'react';
import { TimeInput } from './TimeInput';

const DateTimeReportLine = ({ label, dayData, onAdd, onRemove, onUpdate }) => (
  <div className="event-type-entry">
    <div className="day-header">
      <label>
        <input
          type="checkbox"
          checked={!!dayData}
          onChange={(e) => e.target.checked ? onAdd() : onRemove()}
        />
        <span className="day-name">{label}</span>
      </label>
    </div>

    {dayData && (
      <div className="day-times">
        <span>{dayData.closes ? 'von' : 'um'}</span>
        <TimeInput
          value={dayData.opens || ''}
          onChange={(e) => onUpdate('opens', e.target.value)}
          className="time-input text__input"
        />
        {dayData.closes && (
          <>
            <span>bis</span>
            <TimeInput
              value={dayData.closes}
              onChange={(e) => onUpdate('closes', e.target.value)}
              className="time-input text__input"
            />
          </>
        )}
      </div>
    )}
  </div>
);

export default DateTimeReportLine;
